import * as types from "../../action-types/category/mauPhieuThuCauHinhActionTypes";
import {
  IMauPhieuThuCauHinh,
  IMauPhieuThuCauHinhCreateRequest,
  IMauPhieuThuCauHinhUpdateRequest,
} from "../../../model/respone/category/IMauPhieuThuCauHinh";

export const mauPhieuThuCauHinhActions = {
  SELECT_ALL: () => ({
    type: types.MAU_PHIEU_THU_CAU_HINH_SELECT_ALL,
  }),

  SELECT_ALL_SUCCESS: (data: IMauPhieuThuCauHinh[]) => ({
    type: types.MAU_PHIEU_THU_CAU_HINH_SELECT_ALL_SUCCESS,
    payload: data,
  }),

  SELECT_ALL_ERROR: (error: string) => ({
    type: types.MAU_PHIEU_THU_CAU_HINH_SELECT_ALL_ERROR,
    payload: error,
  }),

  SELECT_BY_ID: (id: number) => ({
    type: types.MAU_PHIEU_THU_CAU_HINH_SELECT_BY_ID,
    payload: id,
  }),

  SELECT_BY_ID_SUCCESS: (data: IMauPhieuThuCauHinh) => ({
    type: types.MAU_PHIEU_THU_CAU_HINH_SELECT_BY_ID_SUCCESS,
    payload: data,
  }),

  SELECT_BY_ID_ERROR: (error: string) => ({
    type: types.MAU_PHIEU_THU_CAU_HINH_SELECT_BY_ID_ERROR,
    payload: error,
  }),

  INSERT: (request: IMauPhieuThuCauHinhCreateRequest) => ({
    type: types.MAU_PHIEU_THU_CAU_HINH_INSERT,
    payload: request,
  }),

  INSERT_SUCCESS: (data: IMauPhieuThuCauHinh) => ({
    type: types.MAU_PHIEU_THU_CAU_HINH_INSERT_SUCCESS,
    payload: data,
  }),

  INSERT_ERROR: (error: string) => ({
    type: types.MAU_PHIEU_THU_CAU_HINH_INSERT_ERROR,
    payload: error,
  }),

  UPDATE: (request: IMauPhieuThuCauHinhUpdateRequest) => ({
    type: types.MAU_PHIEU_THU_CAU_HINH_UPDATE,
    payload: request,
  }),

  UPDATE_SUCCESS: (data: IMauPhieuThuCauHinh) => ({
    type: types.MAU_PHIEU_THU_CAU_HINH_UPDATE_SUCCESS,
    payload: data,
  }),

  UPDATE_ERROR: (error: string) => ({
    type: types.MAU_PHIEU_THU_CAU_HINH_UPDATE_ERROR,
    payload: error,
  }),

  DELETE: (id: number) => ({
    type: types.MAU_PHIEU_THU_CAU_HINH_DELETE,
    payload: id,
  }),

  DELETE_SUCCESS: (id: number) => ({
    type: types.MAU_PHIEU_THU_CAU_HINH_DELETE_SUCCESS,
    payload: id,
  }),

  DELETE_ERROR: (error: string) => ({
    type: types.MAU_PHIEU_THU_CAU_HINH_DELETE_ERROR,
    payload: error,
  }),

  SHOW_HIDE_EDIT_MODAL: (show: boolean, item?: IMauPhieuThuCauHinh) => ({
    type: types.MAU_PHIEU_THU_CAU_HINH_SHOW_HIDE_EDIT_MODAL,
    payload: { show, item },
  }),

  RESET_REQUEST: () => ({
    type: types.MAU_PHIEU_THU_CAU_HINH_RESET_REQUEST,
  }),
};
